// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { companyManagedFragment, viewerFragment } from 'common/fragments'
import { headerFragment } from 'common/fragments/www'
import { convertToSearchSessionIdParams } from 'helpers/search'

const headerQuery = gql`
query HeaderQuery {
  ${headerFragment}
}
`

export default (component: any) => graphql(headerQuery)(component)



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationListPage/graphql.js